import CategoryReducer from "./reducer";

export const setCategoryList = (payload) => (dispatch) => {
  dispatch(CategoryReducer.actions.setCategoryList(payload));
};

export const setCategory = (payload) => (dispatch) => {
  dispatch(CategoryReducer.actions.setCategory(payload));
};

export const updateList = (payload) => (dispatch) => {
  dispatch(CategoryReducer.actions.updateCategory(payload));
};

export const addList = (payload) => (dispatch) => {
  dispatch(CategoryReducer.actions.addList(payload));
};
